import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DirectionType,
    Mutable
} from "../../../../types";
import type {
    TreeViewMeasures
} from "../../type";

export const TREE_VIEW_TOGGLE_QUARTER_TURN = 90;

export const getTreeViewToggleRotation = ({
    direction
}: {
    direction: DirectionType;
}): Array<string> => {
    const sign = direction === "rtl" ? -1 : 1;

    return [
        "0deg",
        `${sign * TREE_VIEW_TOGGLE_QUARTER_TURN}deg`
    ];
};

const stylesheet = StyleSheet.create({
    slot: {
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "stretch",
        flexShrink: 0
    }
});

export const useStyles = ({
    isExpandable,
    measures
}: {
    measures: TreeViewMeasures;
    isExpandable: boolean;
}) => {
    const hitExtra = (measures.toggleHit - measures.slotWidth) / 2;

    const styles = {
        slot: {
            width: measures.slotWidth
        } as Mutable<ViewStyle>
    };

    if(isExpandable) {
        Object.assign(styles.slot, {
            marginHorizontal: -hitExtra,
            width: measures.toggleHit
        });
    }

    return styles;
};
export default stylesheet;
